import type { ActionKitBuilderErrorMapper } from '../action-kit';
import type {
  ActionKitImpErrorNumber,
  ActionKitImpErrorUnauthenticated,
} from './types';
import { UnauthenticatedException } from '../exceptions';

export interface UnauthenticatedErrorMapperResult {
  code: 'unauthenticated';
  data: undefined;
}

export const unauthenticatedErrorMapper: ActionKitBuilderErrorMapper<ActionKitImpErrorUnauthenticated> = (
  errorResult: any,
): UnauthenticatedErrorMapperResult | undefined => {
  if (errorResult.data instanceof UnauthenticatedException) {
    return { code: 'unauthenticated', data: undefined };
  }
  return undefined;
};

/**
 * Función creada solo con propósitos de prueba
 */
export const numberErrorMapper: ActionKitBuilderErrorMapper<ActionKitImpErrorNumber> = (
  errorResult: any,
): ActionKitImpErrorNumber | undefined => {
  if (typeof errorResult.data === 'number') {
    return { code: 'number', data: errorResult.data };
  }
  return undefined;
};
